import React from 'react';
import { Text, DonutChart, Legend, LegendVariants, LegendOrientations } from '@clockout-dev/design-elements';
import SummaryCard from './SummaryCard';
import styles from './styles/donut-breakdown-card.module.scss';

function DonutBreakdownCard({ title, subtitle, total, totalLabel, segments = [] }) {
    const donutData = segments.map(({ label, value, color }) => ({ label, value, color }));
    const legendItems = segments.map(({ label, color, valueLabel, percentLabel }) => ({
        label,
        color,
        value: valueLabel,
        percent: percentLabel,
    }));

    return (
        <SummaryCard title={title} subtitle={subtitle}>
            <div className={styles.body}>
                <div className={styles.chartWrapper}>
                    <DonutChart data={donutData} size={200} formatValue={(value) => value.toLocaleString()} />
                    <div className={styles.center}>
                        <Text as="span" className={styles.total}>{total}</Text>
                        <Text as="span" className={styles.totalLabel}>{totalLabel}</Text>
                    </div>
                </div>
                <Legend
                    variant={LegendVariants.DETAILED}
                    orientation={LegendOrientations.VERTICAL}
                    items={legendItems}
                />
            </div>
        </SummaryCard>
    );
}

export default DonutBreakdownCard;
